/**
 * PWA-safe external link handler
 * Opens external links in a way that works correctly in standalone PWA mode on iOS
 */

export const openExternalLink = (url) => {
  // Check if running in PWA standalone mode
  const isPWA = window.matchMedia('(display-mode: standalone)').matches || 
                window.navigator.standalone === true;
  
  if (isPWA) {
    // In PWA mode, use location.href to open external links
    // This prevents the link from opening inside the PWA shell
    window.location.href = url;
  } else {
    // In browser mode, open in new tab
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

/**
 * Component props for external links
 * Use this with anchor tags to make them PWA-compatible
 */
export const getExternalLinkProps = (url) => ({
  href: url,
  onClick: (e) => {
    const isPWA = window.matchMedia('(display-mode: standalone)').matches || 
                  window.navigator.standalone === true;
    
    if (isPWA) {
      e.preventDefault();
      window.location.href = url;
    }
    // In browser mode, let the default behavior happen with target="_blank"
  },
  target: '_blank',
  rel: 'noopener noreferrer'
});

/**
 * Check if app is running in PWA standalone mode
 */
export const isPWAMode = () => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(display-mode: standalone)').matches || 
         window.navigator.standalone === true ||
         document.referrer.includes('android-app://');
};

export default { openExternalLink, getExternalLinkProps, isPWAMode };
